<template>
    <widget :title="title" :router="router">
        <div class="warp_main">
            <div class="data_tiem">
                <div class="lenged">
                    <span class="have_class"><i></i>上课</span>
                    <span class="no_class"><i></i>周末/寒暑假</span>
                </div>
                <div class="class_data" id="class_data" style="width:360px;"></div>
            </div>
            <div class="class_info">
                <template v-for="term in temrList">
                    <div class="term_name">{{term.termName}}</div>
                    <div class="term_info">{{term.explain}}</div>
                </template>
            </div>
        </div>  
    </widget>
</template>
<script>
    import widget from './zj_warp'
    import widgetFilter from './widgetFilter.js'
    export default {
        components: {
            widget
        },
        props:{
            title:{
                type:String
            },
            swWidth:{
                type:Number,
                default:1
            },
            item:{
                type:Object
            }
        },
        filters:{
            format:function(val){
                return '.'+val.split('.')[1]
            }
        },
        data(){
            return {
                widgetType:1,
                router:'edumanage_schedule_student',
                calendar:null,
                teacherId:window.appframe.$store.state.userInfo.id,
                temrList:[]
            }
        },
        mounted(){
            let vm = this
            vm.$nextTick(function(){
                vm.query()
            })
            
        },
        methods: {
            query(widgetUrl){
                let vm = this
                http.get('/gateway/edumanage/teaching/week/schoolCalendar?teacherId='+vm.teacherId).then(function(xhr){
                    let weekList = xhr.data.data
                    vm.calendar = new calendar();
                    vm.calendar.init({
                        'trigger': '#class_data',
                        'type': 'date',
                        'weekList':weekList
                    });
                })
                http.get('/gateway/edumanage/widget/yearPlanRemarkList?teacherId='+vm.teacherId).then(function(xhr){
                    vm.temrList = xhr.data.data
                })
                
            },
            getTab(data){
                let vm = this
            }
        }
    }
</script>
<style scoped lang="less">
    .warp_main{
        padding: 0 20px;
    }
    .data_tiem{
        width: 360px;
        float: left;
        .lenged{
            margin-bottom: 5px;
            margin-top:-5px;
            text-align: right;
            span{
                margin-left: 20px;
            }
            i{
                width: 12px;
                height: 10px;
                display: inline-block;
                margin-right: 5px;
            }
            .have_class{
                i{
                    background:#333;
                }
            }
            .no_class{
                i{
                    background:#999;
                }
            }
        }
    }
    .class_info{
        margin-left: 380px;
        padding-top: 20px;
        max-height: 270px;
        overflow: auto;
        .term_name{
            background: #EFF3FB;
            text-align:center;
            line-height:28px;
        }
        .term_info{
            margin: 5px 0;
            font-size: 12px;
            color: #333;
            line-height: 18px;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/widget/zj_school_calendar.vue